import React, { useState } from 'react';
import './Faq.css';

// ─── FAQ Data ─────────────────────────────────────────────────────────────────
// You can replace or extend these with any questions relevant to your homepage.

const faqs = [
  {
    q: 'How much do web development services cost in the US?',
    a: 'The cost of web development services in the US depends on the type of website, features, design requirements, and functionality. Basic business websites typically cost less than custom ecommerce platforms or web applications.',
  },
  {
    q: 'How long does it take to develop a website?',
    a: 'Website development timelines vary based on the project size and complexity. A standard business website may take a few weeks, while larger ecommerce or custom web applications can take several months.',
  },
  {
    q: 'What is included in professional web development services?',
    a: 'Professional web development services usually include website design, frontend and backend development, responsive design, SEO optimization, speed optimization, security setup, and ongoing support.',
  },
  {
    q: 'Will my website be mobile-friendly?',
    a: 'Yes, modern web development focuses on responsive design to ensure websites work smoothly across desktops, tablets, and mobile devices for a better user experience.',
  },
  {
    q: 'Do web development companies provide SEO-friendly websites?',
    a: 'Most professional web development companies build websites with SEO best practices, including fast loading speed, clean code structure, mobile responsiveness, and optimized metadata.',
  },
  {
    q: 'Which platform is best for ecommerce website development?',
    a: 'The best ecommerce platform depends on business needs. Popular options include Shopify, WooCommerce, Magento, and custom ecommerce solutions for scalable online stores.',
  },
  {
    q: 'Can I update my website content after development?',
    a: 'Yes, most websites are built with content management systems (CMS) that allow business owners to easily update text, images, products, and other content without technical knowledge.',
  },
];

// ─── FAQItem ──────────────────────────────────────────────────────────────────

function FAQItem({ faq, index }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`faq-item ${open ? 'faq-item--open' : ''}`}>
      <button
        className="faq-trigger"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className="faq-trigger__inner">
          <span className="faq-index">0{index + 1}</span>
          <h4 className="faq-question">{faq.q}</h4>
        </span>
        <span className="faq-icon" aria-hidden="true">+</span>
      </button>

      <div className="faq-body" aria-hidden={!open}>
        <p className="faq-answer">{faq.a}</p>
      </div>
    </div>
  );
}

// ─── HomeFAQ Section ──────────────────────────────────────────────────────────

export default function Faq() {
  return (
    <section className="home-faq-section">
      <div className="container">
        <div className="home-faq-inner">
          <span className="home-faq-badge">FAQs</span>
          <h2 className="home-faq-title">
            Frequently Asked <span>Questions</span>
          </h2>
          <div className="home-faq-list">
            {faqs.map((faq, i) => (
              <FAQItem key={i} faq={faq} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}